import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ListFilter } from '../models/List.Cancellation';

@Injectable({
    providedIn: 'root'
})
export class RefundPolicyService {

    refreshList = new BehaviorSubject<boolean>(false);

    constructor(private http: HttpClient) { }

    getPolicies(filter: ListFilter): any {
        return this.http.post(`${environment.apiUrl}/ResRefundPolicy/ResGetPolicies`, filter);
    }
    GetPolicyById(id: string, restaurantId: number) {
        return this.http.get(`${environment.apiUrl}/ResRefundPolicy/ResGetPolicyById?id=${id}&RestaurantId=${restaurantId}`);
    }
    GetNoShowPolicy(restaurantId: number): any {
        return this.http.get(`${environment.apiUrl}/ResRefundPolicy/ResGetNoShowPolicy?RestaurantId=${restaurantId}`);
    }
    GetExceptionReservationNumber(restaurantId: number): any {
        return this.http.get(`${environment.apiUrl}/ResRefundPolicy/ResGetExceptionReservationNumber?RestaurantId=${restaurantId}`);
    }
    GetExceptionTags(restaurantId: number): any {
        return this.http.get(`${environment.apiUrl}/ResRefundPolicy/ResGetExceptionTags?RestaurantId=${restaurantId}`);
    }
    delete(id: string) {
        return this.http.post(`${environment.apiUrl}/ResRefundPolicy/ResDeleteCancellationPolicy?id=${id}`, null);
    }
    savePolicyRecord(data: any) {
        if (data.id) {
            return this.http.post(`${environment.apiUrl}/ResRefundPolicy/ResEditPolicy`, data);
        } else {
            return this.http.post(`${environment.apiUrl}/ResRefundPolicy/ResNewPolicy`, data);
        }
    }
    GetReservationTimeType(): any {
        return this.http.get(`${environment.apiUrl}/ResRefundPolicy/ResGetReservationTimeType`);
    }
    EditNoShowPolicy(data: any) {
        return this.http.post(`${environment.apiUrl}/ResRefundPolicy/ResEditNoShowPolicy`, data);
    }

    EditReservationNumber(data: any) {
        return this.http.post(`${environment.apiUrl}/ResRefundPolicy/ResEditReservationNumber`, data);
    }

    EditExceptionTags(data: any) {
        return this.http.post(`${environment.apiUrl}/ResRefundPolicy/ResEditExceptionTags`, data);
    }
    ChangePolicyStatus(id: number, Status?: boolean, restaurantId?: number, policyType?: string) {
        return this.http.post(`
        ${environment.apiUrl}/ResRefundPolicy/ResChangePolicyStatus?PolicyId=${id}&RestaurantId=${restaurantId}&policyType=${policyType}&Status=${Status}`, null);
      }
      ChangeExceptionsStatus(Status?: boolean, restaurantId?: number, type?: number) {
        return this.http.post(`
        ${environment.apiUrl}/ResRefundPolicy/ResChangeExceptionsStatus?RestaurantId=${restaurantId}&type=${type}&Status=${Status}`, null);
      }
}
